import styled from 'styled-components'

import { useIntersection } from '@syconium/little-miss-figgy'

import { useCollectionFilterQueryParamsContext } from '../../../../../../../brunswick/containers/CollectionFilterQueryParamsContext'
import { headerHeightPixels } from '../../../../../../constants'
import { NavContainer } from '../../../../../../containers/NavContainer'

import { AppliedFilterLabels } from './AppliedFilterLabels/AppliedFilterLabels'
import { DesktopFilterNav } from './DesktopFilterNav'
import { Body } from './styles'

export const DesktopFilterBar = () => {
  const { clearAllFilters, selectedFilters, toggleSelectedFilter } =
    useCollectionFilterQueryParamsContext()

  const { setFilterBarIsAttachedToNav } = NavContainer.useContainer()

  /* Register when the filter bar's position has reached the bottom of the navigation.*/
  const sentinelRef = useIntersection(
    ([entry]) => {
      setFilterBarIsAttachedToNav(!entry?.isIntersecting)
    },
    {
      root: null,
      rootMargin: `-${headerHeightPixels + 1}px 0px 0px 0px`,
      threshold: 0,
    }
  )

  return (
    <>
      <SentinelRef ref={sentinelRef} />
      <Body>
        <DesktopFilterNav />
        {Object.keys(selectedFilters).length !== 0 && (
          <AppliedFilterLabels
            clearAllFilters={clearAllFilters}
            selectedFilters={selectedFilters}
            toggleSelectedFilter={toggleSelectedFilter}
          />
        )}
      </Body>
    </>
  )
}

const SentinelRef = styled.div`
  height: 0px;
  pointer-events: none;
`
